import { ReactNode } from 'react';

import { ElectricityIconL } from '@lichtblick/icons/svg/electricity/electricity-l';
import { GasIconL } from '@lichtblick/icons/svg/gas/gas-l';

import { LeadFormValues } from './Form.types';

import { B2bLeadFormType } from '../../../types';

type CommodityFields = {
  consumption: keyof LeadFormValues;
  meters: keyof LeadFormValues;
};

type CommodityOption = {
  fields: CommodityFields;
  formName: string;
  headline: string;
  id: string;
  option: {
    fields: CommodityFields;
    headline: string;
    icon: ReactNode;
    label: string;
  };
};

const electricityFields: CommodityFields = {
  consumption: 'energyAnualConsumptionPlan',
  meters: 'energyMeterCount',
};

const gasFields: CommodityFields = {
  consumption: 'gasAnualConsumptionPlan',
  meters: 'gasMeterCount',
};

export const COMMODITIES = {
  ELECTRICITY: {
    fields: electricityFields,
    formName: 'B2BElectricity',
    headline: 'Jetzt GewerbeStrom anfragen',
    id: 'gewerbestrom-formular',
    option: {
      fields: gasFields,
      headline: 'Sind Sie auch an einem ÖkoGas Tarif interessiert?',
      icon: <GasIconL />,
      label: 'GewerbeGas',
    },
  },
  GAS: {
    fields: gasFields,
    formName: 'B2BGas',
    headline: 'Jetzt GewerbeGas anfragen',
    id: 'gewerbegas-formular',
    option: {
      fields: electricityFields,
      headline: 'Sind Sie auch an einem ÖkoStrom Tarif interessiert?',
      icon: <ElectricityIconL />,
      label: 'GewerbeStrom',
    },
  },
} satisfies Record<B2bLeadFormType['commodity'], CommodityOption>;
